(function () {
  const WISHLIST_KEY = 'rawAuraWishlistV1';

  function getWishlist() {
    try {
      const stored =
        localStorage.getItem(
          WISHLIST_KEY
        );

      if (!stored) {
        return [];
      }

      const parsed =
        JSON.parse(stored);

      return Array.isArray(parsed)
        ? [...new Set(parsed.filter(Boolean))]
        : [];

    } catch (error) {
      return [];
    }
  }


  function syncHeaderWishlist() {

    const wishlist =
      getWishlist();


    const count =
      wishlist.length;


    const displayCount =
      count > 99
        ? '99+'
        : String(count);


    document
      .querySelectorAll(
        '[data-ra-header-wishlist]'
      )
      .forEach(link => {

        const bubble =
          link.querySelector(
            '[data-ra-wishlist-bubble]'
          );


        const countElement =
          link.querySelector(
            '[data-ra-wishlist-count]'
          );


        if (countElement) {

          countElement.textContent =
            count > 0
              ? displayCount
              : '';

        }


        if (bubble) {

          bubble.hidden =
            count === 0;

        }


        if (count === 0) {

          link.setAttribute(
            'aria-label',
            'Wishlist'
          );

        } else if (count === 1) {

          link.setAttribute(
            'aria-label',
            'Wishlist, 1 saved item'
          );

        } else {

          link.setAttribute(
            'aria-label',
            `Wishlist, ${count} saved items`
          );

        }

      });

  }


  function initialize() {

    syncHeaderWishlist();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );

  } else {

    initialize();

  }


  /*
   * 当前页面点击商品收藏按钮时
   * raw-aura-commerce.js 会派发这个事件。
   */

  window.addEventListener(
    'raw-aura:wishlist-changed',
    syncHeaderWishlist
  );


  /*
   * 多标签页同步。
   */

  window.addEventListener(
    'storage',
    event => {

      if (
        event.key ===
        WISHLIST_KEY
      ) {

        syncHeaderWishlist();

      }

    }
  );


  /*
   * Shopify Theme Editor
   * 重新加载 Header 后重新同步。
   */

  document.addEventListener(
    'shopify:section:load',
    () => {

      window.setTimeout(
        syncHeaderWishlist,
        30
      );

    }
  );

})();